import { render } from "./MAddToCart.vue?vue&type=template&id=7d137e34&scoped=true&ts=true"
import script from "./MAddToCart.vue?vue&type=script&lang=ts"
export * from "./MAddToCart.vue?vue&type=script&lang=ts"

import "./MAddToCart.vue?vue&type=style&index=0&id=7d137e34&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d137e34"]])

export default __exports__